import { CalendarEvent } from '../components/calendar/Calendar';

export const DUMMY_EVENTS: CalendarEvent[] = [
  {
    id: '1',
    title: 'Design review',
    start: new Date('2023-08-12T10:00:00'),
    end: new Date('2023-08-12T11:00:00'),
  },
  {
    id: '2',
    title: 'Sales meeting',
    start: new Date('2023-07-03T14:00:00'),
    end: new Date('2023-07-03T15:00:00'),
  },
  {
    id: '3',
    title: 'Date night',
    start: new Date('2023-08-08T18:00:00'),
    end: new Date('2023-08-08T21:00:00'),
  },
  {
    id: '4',
    title: "Sam's birthday party",
    start: new Date('2023-08-25T14:00:00'),
    end: new Date('2023-08-25T17:00:00'),
  },
  {
    id: '5',
    title: 'Maple syrup museum',
    start: new Date('2023-09-22T15:00:00'),
    end: new Date('2023-09-22T17:00:00'),
  },
  {
    id: '6',
    title: 'Hockey game',
    start: new Date('2023-09-22T15:30:00'),
    end: new Date('2023-09-22T21:00:00'),
  },
  {
    id: '7',
    title: 'Cinema with friends',
    start: new Date('2023-09-04T21:00:00'),
    end: new Date('2023-09-04T23:00:00'),
  },
  {
    id: '8',
    title: 'Team Building Activity',
    start: new Date('2023-07-10T09:00:00'),
    end: new Date('2023-07-10T17:00:00'),
    description: 'Outdoor activities with the entire team for team cohesion.',
  },
  {
    id: '9',
    title: 'Doctor’s Appointment',
    start: new Date('2023-07-15T10:30:00'),
    end: new Date('2023-07-15T11:30:00'),
  },
  {
    id: '10',
    title: 'Quarterly Review Meeting',
    start: new Date('2023-07-18T13:00:00'),
    end: new Date('2023-07-18T15:00:00'),
    description: 'Review of team performance over the past quarter.',
  },
  {
    id: '11',
    title: 'Board Meeting',
    start: new Date('2023-08-05T10:00:00'),
    end: new Date('2023-08-05T12:00:00'),
  },
  {
    id: '12',
    title: 'Workshop on Digital Marketing',
    start: new Date('2023-08-13T09:00:00'),
    end: new Date('2023-08-13T17:00:00'),
    description: 'A comprehensive workshop on the latest in digital marketing.',
  },
  {
    id: '13',
    title: 'Friend’s Wedding',
    start: new Date('2023-08-20T15:00:00'),
    end: new Date('2023-08-20T23:00:00'),
  },
  {
    id: '14',
    title: 'End of Summer Party',
    start: new Date('2023-08-28T18:00:00'),
    end: new Date('2023-08-28T22:00:00'),
  },
  {
    id: '15',
    title: 'New Project Kick-off',
    start: new Date('2023-09-05T10:00:00'),
    end: new Date('2023-09-05T12:00:00'),
    description: 'Initial meeting for the new client project.',
  },
  {
    id: '16',
    title: 'Conference Call with Overseas Client',
    start: new Date('2023-09-10T09:00:00'),
    end: new Date('2023-09-10T10:00:00'),
  },
  {
    id: '17',
    title: 'Book Club Meeting',
    start: new Date('2023-09-14T19:00:00'),
    end: new Date('2023-09-14T21:00:00'),
    description: 'Discussion on the book of the month with fellow members.',
  },
  {
    id: '18',
    title: 'Family Reunion',
    start: new Date('2023-09-23T12:00:00'),
    end: new Date('2023-09-23T20:00:00'),
  },
  {
    id: '19',
    title: 'Company Retreat',
    start: new Date('2023-09-27T08:00:00'),
    end: new Date('2023-09-29T22:00:00'),
    description: '3-day company retreat for relaxation and strategy planning.',
  },
  {
    id: '20',
    title: 'Yoga Class',
    start: new Date('2023-09-30T07:00:00'),
    end: new Date('2023-09-30T08:00:00'),
  },
];
